module.exports = __webpack_public_path__ + "media/images/lb/073-b13dc8d0c1915a74d4935f7fb8b32e6c.svg";